module.exports = __webpack_public_path__ + "static/media/phone-people-background.ba8fb1d5.jpg";